import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import RegisteredAction from 'src/app/model/registered-action';
import RegisteredActionType from 'src/app/model/registered-action-type';
import { User } from 'src/app/model/user';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _post } from '../../base.service';

@Injectable({
  providedIn: 'root',
})
export class TourInstallerSubmitRegisteredActionsControllerRequestService {
  private static BASE_URL = '/tourInstaller/submitRegisteredActions';
  private readonly post: <T>(
    path: string,
    body: RequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as RegisteredAction[];
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      TourInstallerSubmitRegisteredActionsControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public submitRegisteredActions(
    subProjectId: number,
    registeredActions: RegisteredAction[]
  ): Promise<RegisteredAction[]> {
    const request: RequestBody = {
      subProjectId: subProjectId,
      registeredActions: registeredActions.map((ra) => {
        return {
          date: ra.date,
          type: ra.type,
          user: ra.user,
          localUuid: ra.localUuid,
        };
      }),
    };
    return this.post('', request, this.deserialize).toPromise();
  }
}

interface RequestBody {
  subProjectId: number;
  registeredActions: RequestRegisteredAction[];
}

interface RequestRegisteredAction {
  date: Date;
  type: RegisteredActionType;
  user: User;
  localUuid: string;
}
